import AsyncStorage from '@react-native-async-storage/async-storage';
let _profUserId = 'default'; try { require('@react-native-async-storage/async-storage').default.getItem('userToken').then(function(t){if(t)_profUserId=t.slice(0,16);}).catch(function(){}); } catch(e) {}
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  ScrollView,
  SafeAreaView,
  StatusBar,
  TouchableOpacity,
  Share,
  Alert,
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';

import ProfileManagementService from '../../services/ProfileManagementService';
import PROF_KEYS from '../../constants/profileKeys';

// === API CONFIG ===
const API_BASE = 'https://api.jobeng.ai';
const API_KEY = '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef';
const apiFetch = async (endpoint, options = {}) => {
  try {
    const response = await fetch(`${API_BASE}${endpoint}`, {
      headers: { 'Content-Type': 'application/json', 'x-api-key': API_KEY },
      ...options,
    });
    if (!response.ok) return { error: true, status: response.status };
    return await response.json();
  } catch (err) { return { error: true, message: err.message }; }
};




export default function ResumePreviewScreen({ navigation, route }) {
  // === Live API Data ===
  const [userId, setUserId] = React.useState('default');
  React.useEffect(() => {
    AsyncStorage.getItem('userToken').then(t => { if (t) setUserId(t.slice(0, 16)); }).catch(() => {});
  }, []);

  // Service bootstrap + fallback to profile when no params provided
  const [fallbackData, setFallbackData] = React.useState(null);
  React.useEffect(() => {
    (async () => {
      await ProfileManagementService.bootstrap();
      // If navigation didn't pass resumeData, pull from profile via the service
      if (!route?.params?.resumeData) {
        const r = await ProfileManagementService.getProfile();
        if (r.success) setFallbackData(r.data);
      }
    })();
  }, []);

  const resumeData = route?.params?.resumeData || fallbackData || null;
  React.useEffect(() => {
    if (userId === 'default') return;
    const _ck = `professional_${_profUserId}_resumepreviewscreen`;
    apiFetch('/api/data/customers?limit=1').then(d => {
      if (d && !d.error) {
        const arr = Array.isArray(d) ? d : (d.data || d.results || []);
        AsyncStorage.setItem(_ck, JSON.stringify(arr)).catch(() => {});
      }
    }).catch(() => {});
  }, [userId]);

  // ===== ATS Test (safe defaults) =====
  const atsTest = resumeData?.atsTest || {
    score: 0,
    keywordMatch: 0,
    formatting: 0,
    sections: 0,
    missingKeywords: [],
    recommendations: [],
  };

  // Template colors based on selected template
  const getTemplateColors = () => {
    switch (resumeData?.template) {
      case 'modern':
        return {
          primary: '#0e4e96',
          secondary: '#f1f5f9',
          accent: '#fdb913',
        };
      case 'professional':
        return {
          primary: '#19abb5',
          secondary: '#f1f5f9',
          accent: '#0e4e96',
        };
      case 'creative':
        return {
          primary: '#fdb913',
          secondary: '#f1f5f9',
          accent: '#19abb5',
        };
      case 'executive':
        return {
          primary: '#2c3e50',
          secondary: '#f1f5f9',
          accent: '#e74c3c',
        };
      default:
        return {
          primary: '#0e4e96',
          secondary: '#f1f5f9',
          accent: '#fdb913',
        };
    }
  };

  // Normalize template — some callers pass it top-level, others nested
  const templateColors = getTemplateColors();

  // Share resume
  const shareResume = async () => {
    try {
      await Share.share({
        message: `Check out my professional resume: ${resumeData?.personalInfo?.fullName    || ''} - ${resumeData?.personalInfo?.profession  || ''}`,
        title: `${resumeData?.personalInfo?.fullName    || ''} - Resume`,
      });
    } catch (error) {
      console.log(error.message);
    }
  };

  // Download resume as PDF (mock)
  const downloadResume = () => {
    Alert.alert('Download', 'Resume downloaded successfully!');
  };

  // Run ATS Test (hook for future AI/backend)
  const runAtsTest = () => {
    Alert.alert(
      'ATS Test',
      'This is ready to connect to your ATS/AI service. Send me your backend format and I’ll wire it.'
    );
  };

  // Render the resume based on selected template
  const renderResume = () => {
    return (
      <View style={styles.resumeContainer}>
        {/* Header Section */}
        <View
          style={[
            styles.resumeHeader,
            { backgroundColor: templateColors.primary },
          ]}
        >
          <Text style={styles.resumeName}>
            {resumeData?.personalInfo?.fullName    || ''}
          </Text>
          <Text style={styles.resumeProfession}>
            {resumeData?.personalInfo?.profession  || ''}
          </Text>

          <View style={styles.contactInfoContainer}>
            <View style={styles.contactItem}>
              <Ionicons name="mail-outline" size={16} color="#FFFFFF" />
              <Text style={styles.contactText}>
                {resumeData?.personalInfo?.email       || ''}
              </Text>
            </View>

            <View style={styles.contactItem}>
              <Ionicons name="call-outline" size={16} color="#FFFFFF" />
              <Text style={styles.contactText}>
                {resumeData?.personalInfo?.phone       || ''}
              </Text>
            </View>

            <View style={styles.contactItem}>
              <Ionicons name="location-outline" size={16} color="#FFFFFF" />
              <Text style={styles.contactText}>
                {resumeData?.personalInfo?.location    || ''}
              </Text>
            </View>

            <View style={styles.contactItem}>
              <Ionicons name="logo-linkedin" size={16} color="#FFFFFF" />
              <Text style={styles.contactText}>
                {resumeData?.personalInfo?.linkedin    || ''}
              </Text>
            </View>
          </View>
        </View>

        {/* Summary Section */}
        <View style={styles.resumeSection}>
          <View style={styles.sectionHeader}>
            <Text
              style={[styles.sectionTitle, { color: templateColors.primary }]}
            >
              Professional Summary
            </Text>
            <View
              style={[
                styles.sectionDivider,
                { backgroundColor: templateColors.primary },
              ]}
            />
          </View>

          <Text style={styles.summaryText}>{resumeData?.summary || ''}</Text>
        </View>

        {/* Experience Section */}
        <View style={styles.resumeSection}>
          <View style={styles.sectionHeader}>
            <Text
              style={[styles.sectionTitle, { color: templateColors.primary }]}
            >
              Work Experience
            </Text>
            <View
              style={[
                styles.sectionDivider,
                { backgroundColor: templateColors.primary },
              ]}
            />
          </View>

          {(Array.isArray(resumeData?.experience) ? resumeData.experience : []).map(exp => (
            <View key={exp.id} style={styles.experienceItem}>
              <View style={styles.experienceHeader}>
                <Text style={styles.experienceTitle}>{exp.title}</Text>
                <Text style={styles.experienceDates}>
                  {exp.startDate} - {exp.endDate}
                </Text>
              </View>

              <View style={styles.experienceSubheader}>
                <Text style={styles.experienceCompany}>{exp.company}</Text>
                <Text style={styles.experienceLocation}>{exp.location}</Text>
              </View>

              <Text style={styles.experienceDescription}>
                {exp.description}
              </Text>
            </View>
          ))}
        </View>

        {/* Education Section */}
        <View style={styles.resumeSection}>
          <View style={styles.sectionHeader}>
            <Text
              style={[styles.sectionTitle, { color: templateColors.primary }]}
            >
              Education
            </Text>
            <View
              style={[
                styles.sectionDivider,
                { backgroundColor: templateColors.primary },
              ]}
            />
          </View>

          {(Array.isArray(resumeData?.education) ? resumeData.education : []).map(edu => (
            <View key={edu.id} style={styles.educationItem}>
              <View style={styles.educationHeader}>
                <Text style={styles.educationDegree}>{edu.degree}</Text>
                <Text style={styles.educationDates}>
                  {edu.startDate} - {edu.endDate}
                </Text>
              </View>

              <View style={styles.educationSubheader}>
                <Text style={styles.educationInstitution}>
                  {edu.institution}
                </Text>
                <Text style={styles.educationLocation}>{edu.location}</Text>
              </View>

              {edu.description && (
                <Text style={styles.educationDescription}>
                  {edu.description}
                </Text>
              )}
            </View>
          ))}
        </View>

        {/* Skills Section */}
        <View style={styles.resumeSection}>
          <View style={styles.sectionHeader}>
            <Text
              style={[styles.sectionTitle, { color: templateColors.primary }]}
            >
              Skills
            </Text>
            <View
              style={[
                styles.sectionDivider,
                { backgroundColor: templateColors.primary },
              ]}
            />
          </View>

          <View style={styles.skillsContainer}>
            {(Array.isArray(resumeData?.skills) ? resumeData.skills : []).map((skill, index) => (
              <View
                key={index}
                style={[
                  styles.skillItem,
                  {
                    backgroundColor: templateColors.secondary,
                    borderColor: templateColors.primary,
                  },
                ]}
              >
                <Text
                  style={[styles.skillText, { color: templateColors.primary }]}
                >
                  {typeof skill === 'object' ? skill.name : skill}
                </Text>
              </View>
            ))}
          </View>
        </View>

        {/* AI-Optimized Badge */}
        <View
          style={[styles.aiBadge, { backgroundColor: templateColors.accent }]}
        >
          <Ionicons name="flash" size={16} color="#FFFFFF" />
          <Text style={styles.aiBadgeText}>AI-Optimized</Text>
        </View>
      </View>
    );
  };

  const renderAtsTest = () => {
    // Simple coloring for score
    const score = Number(atsTest?.score || 0);
    const scoreColor =
      score >= 80 ? '#10B981' : score >= 60 ? '#F97316' : '#EF4444';

    const hasMissingKeywords =
      Array.isArray(atsTest?.missingKeywords) && atsTest.missingKeywords.length;

    const hasRecs =
      Array.isArray(atsTest?.recommendations) && atsTest.recommendations.length;

    return (
      <View style={styles.atsContainer}>
        <View style={styles.atsHeader}>
          <Ionicons name="analytics" size={22} color="#0e4e96" />
          <Text style={styles.atsTitle}>ATS Compatibility Test</Text>
        </View>

        <View style={styles.atsScoreRow}>
          <Text style={[styles.atsScore, { color: scoreColor }]}>{score}%</Text>
          <Text style={styles.atsSubtitle}>ATS Match Score</Text>
        </View>

        <View style={styles.atsMetrics}>
          <Text style={styles.atsMetricText}>
            Keyword Match: {Number(atsTest.keywordMatch || 0)}%
          </Text>
          <Text style={styles.atsMetricText}>
            Formatting: {Number(atsTest.formatting || 0)}%
          </Text>
          <Text style={styles.atsMetricText}>
            Sections: {Number(atsTest.sections || 0)}%
          </Text>
        </View>

        {hasMissingKeywords ? (
          <>
            <Text style={styles.atsWarningTitle}>Missing Keywords</Text>
            <View style={styles.keywordContainer}>
              {atsTest.missingKeywords.map((kw, i) => (
                <View key={`${kw}-${i}`} style={styles.keywordChip}>
                  <Text style={styles.keywordText}>{kw}</Text>
                </View>
              ))}
            </View>
          </>
        ) : null}

        {hasRecs ? (
          <>
            <Text style={styles.atsRecsTitle}>Recommendations</Text>
            {atsTest.recommendations.slice(0, 4).map((rec, i) => (
              <View key={`${rec}-${i}`} style={styles.atsRecItem}>
                <Ionicons name="sparkles" size={16} color="#0e4e96" />
                <Text style={styles.atsRecText}>{rec}</Text>
              </View>
            ))}
          </>
        ) : null}

        <TouchableOpacity style={styles.runAtsButton} onPress={runAtsTest}>
          <Ionicons name="play-circle-outline" size={20} color="#FFFFFF" />
          <Text style={styles.runAtsButtonText}>Run ATS Test</Text>
        </TouchableOpacity>
      </View>
    );
  };

  // ── Guard: if no resume data, show a friendly empty state ─────────────────
  if (!resumeData) {
    return (
      <SafeAreaView style={styles.safeArea}>
        <StatusBar barStyle="dark-content" backgroundColor="#F8FAFC" />
        <View style={styles.header}>
          <TouchableOpacity style={styles.backButton} onPress={() => navigation.goBack()}>
            <Ionicons name="arrow-back" size={24} color="#0e4e96" />
          </TouchableOpacity>
          <View style={styles.headerTitleContainer}>
            <Text style={styles.headerTitle}>Resume Preview</Text>
          </View>
          <View style={{ width: 40 }} />
        </View>
        <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', padding: 32 }}>
          <Ionicons name="document-text-outline" size={64} color="#CBD5E1" />
          <Text style={{ fontSize: 18, fontWeight: '700', color: '#374151', marginTop: 16, textAlign: 'center' }}>
            No Resume Data
          </Text>
          <Text style={{ fontSize: 14, color: '#94A3B8', marginTop: 8, textAlign: 'center', lineHeight: 20 }}>
            Please build your resume first using the Build Resume screen.
          </Text>
          <TouchableOpacity
            style={{ marginTop: 24, backgroundColor: '#0e4e96', borderRadius: 12, paddingHorizontal: 24, paddingVertical: 14 }}
            onPress={() => navigation.navigate('BuildResume')}
          >
            <Text style={{ color: '#FFF', fontWeight: '700', fontSize: 15 }}>Build Resume</Text>
          </TouchableOpacity>
        </View>
      </SafeAreaView>
    );
  }

  return (
    <SafeAreaView style={styles.safeArea}>
      <StatusBar barStyle="dark-content" backgroundColor="#F8FAFC" />

      <View style={styles.header}>
        <TouchableOpacity
          style={styles.backButton}
          onPress={() => navigation.goBack()}
        >
          <Ionicons name="arrow-back" size={24} color="#0e4e96" />
        </TouchableOpacity>

        <View style={styles.headerTitleContainer}>
          <Text style={styles.headerTitle}>Resume Preview</Text>
        </View>

        <TouchableOpacity style={styles.helpButton}>
          <Ionicons name="help-circle-outline" size={24} color="#0e4e96" />
        </TouchableOpacity>
      </View>

      <ScrollView
        style={styles.scrollView}
        showsVerticalScrollIndicator={false}
      >
        <View style={styles.container}>
          <View style={styles.scoreContainer}>
            <View style={styles.scoreCircle}>
              <Text style={styles.scoreNumber}>{resumeData?.resumeScore ?? 0}</Text>
              <Text style={styles.scoreLabel}>Score</Text>
            </View>

            <View style={styles.scoreDetails}>
              <Text style={styles.scoreTitle}>Resume Score</Text>
              <Text style={styles.scoreDescription}>
                Your resume is excellent and optimized for job applications.
              </Text>

              <View style={styles.scoreTag}>
                <Ionicons name="checkmark-circle" size={16} color="#10B981" />
                <Text style={styles.scoreTagText}>ATS-Friendly</Text>
              </View>
            </View>
          </View>

          {/* ✅ NEW: ATS Test Section */}
          {renderAtsTest()}

          {renderResume()}

          <View style={styles.actionButtons}>
            <TouchableOpacity
              style={[styles.actionButton, styles.downloadButton]}
              onPress={downloadResume}
            >
              <Ionicons name="download-outline" size={20} color="#FFFFFF" />
              <Text style={styles.actionButtonText}>Download PDF</Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={[styles.actionButton, styles.shareButton]}
              onPress={shareResume}
            >
              <Ionicons name="share-social-outline" size={20} color="#FFFFFF" />
              <Text style={styles.actionButtonText}>Share</Text>
            </TouchableOpacity>
          </View>

          <View style={styles.feedbackContainer}>
            <Text style={styles.feedbackTitle}>AI Feedback</Text>

            <View style={styles.feedbackItem}>
              <Ionicons name="checkmark-circle" size={20} color="#10B981" />
              <Text style={styles.feedbackText}>
                Strong professional summary that highlights key achievements
              </Text>
            </View>

            <View style={styles.feedbackItem}>
              <Ionicons name="checkmark-circle" size={20} color="#10B981" />
              <Text style={styles.feedbackText}>
                Good use of action verbs and quantifiable results
              </Text>
            </View>

            <View style={styles.feedbackItem}>
              <Ionicons name="alert-circle" size={20} color="#F97316" />
              <Text style={styles.feedbackText}>
                Consider adding more industry-specific keywords
              </Text>
            </View>

            <TouchableOpacity style={styles.improveButton}>
              <Text style={styles.improveButtonText}>Improve with AI</Text>
            </TouchableOpacity>
          </View>

          <View style={styles.nextStepsContainer}>
            <Text style={styles.nextStepsTitle}>Next Steps</Text>

            <TouchableOpacity
              style={styles.nextStepItem}
              onPress={() => navigation.navigate('CreateCoverLetter')}
            >
              <View style={styles.nextStepIconContainer}>
                <Ionicons name="document-text" size={24} color="#FFFFFF" />
              </View>
              <View style={styles.nextStepContent}>
                <Text style={styles.nextStepTitle}>Create a Cover Letter</Text>
                <Text style={styles.nextStepDescription}>
                  Match your resume with a professional cover letter
                </Text>
              </View>
              <Ionicons name="chevron-forward" size={24} color="#64748B" />
            </TouchableOpacity>

            <TouchableOpacity
              style={styles.nextStepItem}
              onPress={() => navigation.navigate('SearchJobs')}
            >
              <View
                style={[
                  styles.nextStepIconContainer,
                  { backgroundColor: '#19abb5' },
                ]}
              >
                <Ionicons name="search" size={24} color="#FFFFFF" />
              </View>
              <View style={styles.nextStepContent}>
                <Text style={styles.nextStepTitle}>Find Matching Jobs</Text>
                <Text style={styles.nextStepDescription}>
                  Discover jobs that match your skills and experience
                </Text>
              </View>
              <Ionicons name="chevron-forward" size={24} color="#64748B" />
            </TouchableOpacity>
          </View>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: '#F8FAFC',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingVertical: 12,
    backgroundColor: '#FFFFFF',
    borderBottomWidth: 1,
    borderBottomColor: '#E2E8F0',
  },
  backButton: {
    padding: 8,
  },
  headerTitleContainer: {
    flex: 1,
    alignItems: 'center',
  },
  headerTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#0F172A',
  },
  helpButton: {
    padding: 8,
  },
  scrollView: {
    flex: 1,
  },
  container: {
    padding: 16,
    paddingBottom: 32,
  },

  // Score card
  scoreContainer: {
    flexDirection: 'row',
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    padding: 16,
    marginBottom: 16,
    borderWidth: 1,
    borderColor: '#E2E8F0',
    alignItems: 'center',
  },
  scoreCircle: {
    width: 80,
    height: 80,
    borderRadius: 40,
    backgroundColor: '#F1F5F9',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 16,
  },
  scoreNumber: {
    fontSize: 24,
    fontWeight: '700',
    color: '#0e4e96',
  },
  scoreLabel: {
    fontSize: 12,
    color: '#64748B',
  },
  scoreDetails: {
    flex: 1,
  },
  scoreTitle: {
    fontSize: 18,
    fontWeight: '700',
    color: '#0F172A',
    marginBottom: 4,
  },
  scoreDescription: {
    fontSize: 14,
    color: '#64748B',
    marginBottom: 8,
  },
  scoreTag: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#ECFDF5',
    paddingVertical: 4,
    paddingHorizontal: 8,
    borderRadius: 4,
    alignSelf: 'flex-start',
  },
  scoreTagText: {
    fontSize: 12,
    color: '#10B981',
    marginLeft: 4,
    fontWeight: '600',
  },

  // ✅ ATS
  atsContainer: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    padding: 16,
    marginBottom: 24,
    borderWidth: 1,
    borderColor: '#E2E8F0',
  },
  atsHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
  },
  atsTitle: {
    fontSize: 18,
    fontWeight: '700',
    marginLeft: 8,
    color: '#0F172A',
  },
  atsScoreRow: {
    alignItems: 'center',
    marginBottom: 12,
  },
  atsScore: {
    fontSize: 32,
    fontWeight: '800',
  },
  atsSubtitle: {
    fontSize: 14,
    color: '#64748B',
  },
  atsMetrics: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 12,
  },
  atsMetricText: {
    fontSize: 13,
    color: '#0F172A',
  },
  atsWarningTitle: {
    fontSize: 14,
    fontWeight: '700',
    marginBottom: 6,
    color: '#F97316',
  },
  keywordContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 12,
  },
  keywordChip: {
    backgroundColor: '#FFF7ED',
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 12,
    marginRight: 6,
    marginBottom: 6,
  },
  keywordText: {
    fontSize: 12,
    color: '#C2410C',
    fontWeight: '600',
  },
  atsRecsTitle: {
    fontSize: 14,
    fontWeight: '700',
    marginBottom: 8,
    color: '#0F172A',
  },
  atsRecItem: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 8,
  },
  atsRecText: {
    flex: 1,
    marginLeft: 10,
    fontSize: 13,
    color: '#0F172A',
    lineHeight: 18,
  },
  runAtsButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#0e4e96',
    paddingVertical: 12,
    borderRadius: 12,
    marginTop: 8,
  },
  runAtsButtonText: {
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: '700',
    marginLeft: 8,
  },

  // Resume card
  resumeContainer: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    overflow: 'hidden',
    borderWidth: 1,
    borderColor: '#E2E8F0',
    marginBottom: 24,
  },
  resumeHeader: {
    padding: 24,
  },
  resumeName: {
    fontSize: 24,
    fontWeight: '700',
    color: '#FFFFFF',
    marginBottom: 4,
  },
  resumeProfession: {
    fontSize: 16,
    color: '#FFFFFF',
    opacity: 0.9,
    marginBottom: 16,
  },
  contactInfoContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  contactItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 16,
    marginBottom: 8,
  },
  contactText: {
    fontSize: 12,
    color: '#FFFFFF',
    marginLeft: 4,
  },
  resumeSection: {
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#E2E8F0',
  },
  sectionHeader: {
    marginBottom: 16,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: '700',
    marginBottom: 8,
  },
  sectionDivider: {
    height: 3,
    width: 40,
    borderRadius: 1.5,
  },
  summaryText: {
    fontSize: 14,
    color: '#0F172A',
    lineHeight: 20,
  },
  experienceItem: {
    marginBottom: 16,
  },
  experienceHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  experienceTitle: {
    fontSize: 16,
    fontWeight: '700',
    color: '#0F172A',
    flex: 1,
  },
  experienceDates: {
    fontSize: 14,
    color: '#64748B',
  },
  experienceSubheader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  experienceCompany: {
    fontSize: 14,
    color: '#0F172A',
  },
  experienceLocation: {
    fontSize: 14,
    color: '#64748B',
  },
  experienceDescription: {
    fontSize: 14,
    color: '#0F172A',
    lineHeight: 20,
  },
  educationItem: {
    marginBottom: 16,
  },
  educationHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  educationDegree: {
    fontSize: 16,
    fontWeight: '700',
    color: '#0F172A',
    flex: 1,
  },
  educationDates: {
    fontSize: 14,
    color: '#64748B',
  },
  educationSubheader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  educationInstitution: {
    fontSize: 14,
    color: '#0F172A',
  },
  educationLocation: {
    fontSize: 14,
    color: '#64748B',
  },
  educationDescription: {
    fontSize: 14,
    color: '#0F172A',
    lineHeight: 20,
  },
  skillsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  skillItem: {
    paddingVertical: 6,
    paddingHorizontal: 12,
    borderRadius: 16,
    marginRight: 8,
    marginBottom: 8,
    borderWidth: 1,
  },
  skillText: {
    fontSize: 14,
    fontWeight: '500',
  },
  aiBadge: {
    position: 'absolute',
    top: 16,
    right: 16,
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 4,
    paddingHorizontal: 8,
    borderRadius: 12,
  },
  aiBadgeText: {
    fontSize: 12,
    color: '#FFFFFF',
    fontWeight: '700',
    marginLeft: 4,
  },

  // Actions
  actionButtons: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 24,
  },
  actionButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 12,
    borderRadius: 12,
    flex: 1,
  },
  downloadButton: {
    backgroundColor: '#0e4e96',
    marginRight: 8,
  },
  shareButton: {
    backgroundColor: '#19abb5',
    marginLeft: 8,
  },
  actionButtonText: {
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: '600',
    marginLeft: 8,
  },

  // Feedback
  feedbackContainer: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    padding: 16,
    marginBottom: 24,
    borderWidth: 1,
    borderColor: '#E2E8F0',
  },
  feedbackTitle: {
    fontSize: 18,
    fontWeight: '700',
    color: '#0F172A',
    marginBottom: 16,
  },
  feedbackItem: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 12,
  },
  feedbackText: {
    fontSize: 14,
    color: '#0F172A',
    marginLeft: 12,
    flex: 1,
  },
  improveButton: {
    backgroundColor: '#fdb913',
    paddingVertical: 12,
    borderRadius: 12,
    alignItems: 'center',
    marginTop: 8,
  },
  improveButtonText: {
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: '600',
  },

  // Next steps
  nextStepsContainer: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    padding: 16,
    borderWidth: 1,
    borderColor: '#E2E8F0',
  },
  nextStepsTitle: {
    fontSize: 18,
    fontWeight: '700',
    color: '#0F172A',
    marginBottom: 16,
  },
  nextStepItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#E2E8F0',
  },
  nextStepIconContainer: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: '#0e4e96',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
  },
  nextStepContent: {
    flex: 1,
  },
  nextStepTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#0F172A',
    marginBottom: 4,
  },
  nextStepDescription: {
    fontSize: 14,
    color: '#64748B',
  },
});
